module.exports = __webpack_public_path__ + "static/img/areaA-6.859cecb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-6.png
// module id = 953
// module chunks = 1